import { UAParser } from "ua-parser-js";
import { v4 as uuidv4 } from "uuid";
import { secureStorage } from './encryption';
import { AuthStoreKeys } from '@/app/constants/storeEnums';

export interface PlatformInfo {
  browser: string | undefined;
  browserVersion: string | undefined;
  os: string | undefined;
  osVersion: string | undefined;
  deviceType: string | undefined;
}

/**
 * Generate a stable deviceId and store it encrypted
 */
export const generateDeviceId = (): string => {
  const deviceId = uuidv4();
  secureStorage.setItem(AuthStoreKeys.DeviceId, deviceId);
  return deviceId;
};

/**
 * Get the deviceId from encrypted localStorage
 */
export const getDeviceId = (): string => {
  const deviceId = secureStorage.getItem<string>(AuthStoreKeys.DeviceId);
  return deviceId || "";
};

/**
 * Collect platform/browser/device details
 */
export const getPlatformInfo = (): PlatformInfo => {
  const parser = new UAParser();
  const result = parser.getResult();

  return {
    browser: result.browser.name?.toUpperCase(),
    browserVersion: result.browser.version,
    os: result.os.name,
    osVersion: result.os.version,
    deviceType: result.device.type || "desktop"
  };
};
